import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser, apiError, resetLoginFlag } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik validation
import logoLight from "../../assets/images/logo-light.png";
const Login = (props) => {
  const inputPassRef = useRef(null);
  const dispatch = useDispatch();

  const { user } = useSelector((state) => ({
    user: state.Account.user,
  }));
  const [userLogin, setUserLogin] = useState([]);
  useEffect(() => {
    if (user && user) {
      setUserLogin({
        email: user.user.email,
        password: user.user.confirm_password,
      });
    }
  }, [user]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      clientAppId: 1,
      username: userLogin.username ?? "",
      password: userLogin.password ?? "",
    },
    validationSchema: Yup.object({
      // username: Yup.string().required("Please Enter Your Username"),
      // password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate, "/dashboard"));
    },
  });

  const { loading, error } = useSelector((state) => ({
    loading: state.Login.loading,
    error: state.Login.error,
  }));
  document.title = "Login | Enterprise Resources Planning ";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center mt-5">
              <Col md={8} lg={6} xl={5} className="mt-5 pt-5">
                <Card className="mt-5">
                  <CardBody className="p-4">
                    <div className="text-center mb-3">
                      <div>
                        <a href="http://pkdeveloper.id" className="d-inline-block auth-logo">
                          <img src={logoLight} alt="" height="80" />
                        </a>
                      </div>
                      <h5 className="text-primary mt-3">ENTERPRISE RESOURCE PLANNING</h5>
                      <p className="text-muted">Please sign in to continue.</p>
                    </div>
                    <div className="p-2 mt-2">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#">
                        {error && error.response ? (
                          <Alert color="danger">
                            <div>{error.response.data.message}</div>
                          </Alert>
                        ) : null}

                        <div className="mb-3">
                          <Label htmlFor="username" className="form-label">
                            Username
                          </Label>
                          <Input name="username" className="form-control" placeholder="Enter Username" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.username ?? ""} invalid={validation.touched.username && validation.errors.username ? true : false} />
                          {validation.touched.username && validation.errors.username ? <FormFeedback type="invalid">{validation.errors.username}</FormFeedback> : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label" htmlFor="password-input">
                            Password
                          </Label>
                          <div ref={inputPassRef} className="position-relative auth-pass-inputgroup mb-3">
                            <Input name="password" value={validation.values.password ?? ""} type="password" className="form-control pe-5" placeholder="Enter Password" onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={validation.touched.password && validation.errors.password ? true : false} />
                            {validation.touched.password && validation.errors.password ? <FormFeedback type="invalid">{validation.errors.password}</FormFeedback> : null}
                            <button
                              onClick={(e) => {
                                if (inputPassRef.current.firstElementChild.type === "password") {
                                  inputPassRef.current.firstElementChild.type = "text";
                                } else {
                                  inputPassRef.current.firstElementChild.type = "password";
                                }
                              }}
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"><i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        <div className="form-check">
                          <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                          <Label className="form-check-label" htmlFor="auth-remember-check">
                            Remember me
                          </Label>
                        </div>

                        <div className="mt-4">
                          <Button color="success" className="btn btn-success w-100" type="submit">
                            <span className="d-flex align-items-center justify-content-center">
                              <span className="me-2">Sign In</span>
                              {loading && (
                                <Spinner size="sm" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
